/**
 * Destinazione interna di un link di accesso (parametro "next").
 *
 * I link delle email e dei messaggi WhatsApp portano a una pagina precisa del
 * portale. La destinazione viaggia dentro "next" e attraversa la schermata di
 * accesso, il magic link e l'SSO da biounica.it: senza, ogni link finirebbe in
 * dashboard. Si accettano solo percorsi interni, così il parametro non può
 * diventare un reindirizzamento verso un altro sito.
 */
const AMMESSO = /^\/[A-Za-z0-9\-._~/]*(\?[A-Za-z0-9\-._~/=&%+]*)?$/;

/** Ritorna la destinazione se è un percorso interno, altrimenti null. */
export function nextSicuro(valore) {
  if (!valore || typeof valore !== 'string' || valore.length > 300) return null;
  if (valore.startsWith('//') || valore.includes('\\')) return null;
  return AMMESSO.test(valore) ? valore : null;
}

/** Il percorso corrente, con la querystring, pronto da mettere in "next". */
export function destinazioneCorrente(location) {
  return `${location.pathname}${location.search || ''}`;
}

/** "/login?next=..." oppure "/login" se la destinazione è già la dashboard. */
export function loginConNext(destinazione) {
  const dest = nextSicuro(destinazione);
  if (!dest || dest === '/dashboard') return '/login';
  return `/login?next=${encodeURIComponent(dest)}`;
}
